export default "__VITE_ASSET__b51d0b45__"